import { action, computed, configure, decorate, observable, runInAction } from 'mobx';
import { error, fetchData, RootStore } from './RootStore';

configure({ enforceActions: 'observed' });

export type PhasesProps = {
  phasePos: string;
  phaseId: string;
  phaseName: string;
  phaseColor: string;
  phaseIcon: string;
  phaseDesc: string;
  phaseSub: string | PhasesProps[];
  phasePath: string;
  phaseNumber?: string;
};

// type phasesType = PhasesProps[] | null;
export class PhasesStore {
  rootStore: RootStore;
  phasesArray: PhasesProps[] | null;
  isPending: boolean;
  currentPhaseId: string | null;
  error: error;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.phasesArray = null;
    this.isPending = true;
    this.error = null;
    this.currentPhaseId = '';
  }

  getPhases = async (url: string, path: string = '') => {
    if (this.phasesArray) {
      this.setCurrentId(path);
      return;
    }

    this.isPending = true;
    this.error = null;

    try {
      const phases: PhasesProps[] | null = await fetchData(url);
      runInAction(() => {
        this.isPending = false;
        this.phasesArray = phases;
        this.setCurrentId(path);
      });
    } catch (error) {
      runInAction(() => {
        this.error = { name: error.name, message: error.message };
        this.isPending = false;
      });
    }
  };

  convertIds(ids: number[]): { [key: string]: number } {
    return ids.reduce((obj, id) => ({ ...obj, [id]: id }), {});
  }

  findPhases(ids: number[]) {
    const idsObj = ids.length > 0 ? this.convertIds(ids) : null;
    return this.phasesArray && idsObj
      ? this.phasesArray.filter(phase => idsObj[phase.phaseId])
      : '';
  }

  reducePhases(phases: PhasesProps[]) {
    const tempSubPhasesIds: { [key: string]: number } = {};
    const tempPhases = phases.reduce(
      (newPhases, phase) => {
        const subPhasesIds: [] | null = phase.phaseSub
          ? JSON.parse(phase.phaseSub as string)
          : null;
        const subPhases = subPhasesIds ? this.findPhases(subPhasesIds) : '';
        Object.assign(tempSubPhasesIds, subPhasesIds && this.convertIds(subPhasesIds));
        return newPhases.concat({
          ...phase,
          phaseSub: subPhases,
        });
      },
      [] as PhasesProps[]
    );
    return tempPhases.filter(phase => !tempSubPhasesIds[phase.phaseId]);
  }

  get phases(): PhasesProps[] | null {
    return this.phasesArray ? this.reducePhases(this.phasesArray) : null;
  }

  setCurrentId(path: string) {
    if (path === '') {
      this.currentPhaseId = null;
      return;
    }
    const findPhase =
      this.phasesArray &&
      this.phasesArray.find(phase => phase.phasePath.indexOf(path) !== -1) !== undefined
        ? this.phasesArray.find(phase => phase.phasePath.indexOf(path) !== -1)
        : null;
    this.currentPhaseId = findPhase ? findPhase.phaseId : null;
  }
}

decorate(PhasesStore, {
  currentPhaseId: observable,
  getPhases: action,
  isPending: observable,
  phases: computed,
  phasesArray: observable,
  setCurrentId: action,
});
